import { render, staticRenderFns } from "./TariffModifierList.vue?vue&type=template&id=37a91d76&"
import script from "./TariffModifierList.vue?vue&type=script&lang=js&"
export * from "./TariffModifierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports